import { IExam } from "@/@types";
import { Svg } from "@/components";
import { ColumnHeader } from "@/components/data-table/column-header";
import { StatusCard } from "@/components/status-card";
import { ColumnDef } from "@tanstack/react-table";
import { format } from "date-fns";

export const TABLE_COLUMNS: ColumnDef<IExam>[] = [
  {
    id: "name",
    accessorKey: "lesson.title || module.name",
    header: ({ column }) => <ColumnHeader column={column} title="Name" />,
    cell: ({ row }) => (
      <div className="flex gap-2 items-center">
        <Svg src="/icons/tests_&_exams.svg" className="max-w-6" />
        <span>{row.original.name}</span>
      </div>
    ),
    filterFn: (row, id, value) => {
      const cellValue = String(row.getValue(id)).toLowerCase();
      return (
        (cellValue.includes(String(value).toLowerCase()) ||
          cellValue.startsWith(String(value).toLowerCase()) ||
          row.original.lessonName
            ?.toLowerCase()
            .includes(String(value).toLowerCase()) ||
          row.original.examLevel
            ?.toString()
            .toLowerCase()
            .includes(String(value).toLowerCase()) ||
          row.original.name
            ?.toLowerCase()
            .includes(String(value).toLowerCase())) ??
        false
      );
    },
  },
  {
    id: "lessonName",
    accessorKey: "lessonName",
    header: "Associado a",
    cell: ({ row }) =>
      row.original.lessonName ||
      row.original.moduleName ||
      (row.original.examLevel
        ? `Exame do nível ${row.original.examLevel}`
        : "-"),
    filterFn: (row, id, value) => String(value).includes(row.getValue(id)),
  },
  {
    id: "duration",
    accessorKey: "duration",
    header: "Duration (min)",
    cell: ({ row }) => row.original.duration || "-",
    filterFn: (row, id, value) => String(value).includes(row.getValue(id)),
  },
  {
    id: "createdAt",
    accessorKey: "createdAt",
    header: "Data de criação",
    cell: ({ row }) => {
      const date = row.original.createdAt;

      return date ? format(date, "dd/MM/yyy - HH:mm") : "-";
    },
    filterFn: (row, id, value) => String(value).includes(row.getValue(id)),
  },
  {
    id: "type",
    accessorKey: "type",
    header: "Tipo",
    cell: ({ row }) => {
      const type = row.original.type;
      return type || "-";
    },
    filterFn: (row, id, value) => {
      const cellValue = String(row.getValue(id)).toLowerCase();
      return cellValue.includes(String(value).toLowerCase());
    },
  },
  {
    id: "t_status",
    accessorKey: "t_status",
    header: ({ column }) => (
      <ColumnHeader className="justify-center" column={column} title="Estado" />
    ),
    cell: ({ row }) => {
      const status = row.original.status;

      let customBg = "";
      let stateText = "";
      let customBorder = "";

      switch (status) {
        case "DISABLED":
          stateText = "Desativado";
          customBg = "#F95A4855";
          customBorder = "#F95A48";
          break;
        case "PENDING":
          customBg = "#FFBD2E55";
          stateText = "Pendente";
          customBorder = "#FFBD2E";
          break;
        case "ACTIVE":
          stateText = "Ativo";
          customBg = "#72B84A55";
          customBorder = "#72B84A";
          break;
      }

      return (
        <StatusCard
          className="mr-4 ml-0"
          customBg={customBg}
          customBorder={customBorder}
        >
          {stateText}
        </StatusCard>
      );
    },
  },
];
